import isMobile from '../lib/isMobile';

export default {
  methods: {
    isMobile,
    isValidEmail(email) {
      const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    },
    isDDDValid(phone) {
      const dddObject = {
        11: { city: 'São Paulo', state: 'SP' },
        12: { city: 'São José dos Campos', state: 'SP' },
        13: { city: 'Santos', state: 'SP' },
        14: { city: 'Bauru', state: 'SP' },
        15: { city: 'Sorocaba', state: 'SP' },
        16: { city: 'Ribeirão Preto', state: 'SP' },
        17: { city: 'São José do Rio Preto', state: 'SP' },
        18: { city: 'Presidente Prudente', state: 'SP' },
        19: { city: 'Campinas', state: 'SP' },
        21: { city: 'Rio de Janeiro', state: 'RJ' },
        22: { city: 'Campos dos Goytacazes', state: 'RJ' },
        24: { city: 'Volta Redonda', state: 'RJ' },
        27: { city: 'Vila Velha/Vitória', state: 'ES' },
        28: { city: 'Cachoeiro de Itapemirim', state: 'ES' },
        31: { city: 'Belo Horizonte', state: 'MG' },
        32: { city: 'Juiz de Fora', state: 'MG' },
        33: { city: 'Governador Valadares', state: 'MG' },
        34: { city: 'Uberlândia', state: 'MG' },
        35: { city: 'Poços de Caldas', state: 'MG' },
        37: { city: 'Divinópolis', state: 'MG' },
        38: { city: 'Montes Claros', state: 'MG' },
        41: { city: 'Curitiba', state: 'PR' },
        42: { city: 'Ponta Grossa', state: 'PR' },
        43: { city: 'Londrina', state: 'PR' },
        44: { city: 'Maringá', state: 'PR' },
        45: { city: 'Foz do Iguaçú', state: 'PR' },
        46: { city: 'Francisco Beltrão/Pato Branco', state: 'PR' },
        47: { city: 'Joinville', state: 'SC' },
        48: { city: 'Florianópolis', state: 'SC' },
        49: { city: 'Chapecó', state: 'SC' },
        51: { city: 'Porto Alegre', state: 'RS' },
        53: { city: 'Pelotas', state: 'RS' },
        54: { city: 'Caxias do Sul', state: 'RS' },
        55: { city: 'Santa Maria', state: 'RS' },
        61: { city: 'Brasília', state: 'DF' },
        62: { city: 'Goiânia', state: 'GO' },
        63: { city: 'Palmas', state: 'TO' },
        64: { city: 'Rio Verde', state: 'GO' },
        65: { city: 'Cuiabá', state: 'MT' },
        66: { city: 'Rondonópolis', state: 'MT' },
        67: { city: 'Campo Grande', state: 'MS' },
        68: { city: 'Rio Branco', state: 'AC' },
        69: { city: 'Porto Velho', state: 'RO' },
        71: { city: 'Salvador', state: 'BA' },
        73: { city: 'Ilhéus', state: 'BA' },
        74: { city: 'Juazeiro', state: 'BA' },
        75: { city: 'Feira de Santana', state: 'BA' },
        77: { city: 'Barreiras', state: 'BA' },
        79: { city: 'Aracaju', state: 'SE' },
        81: { city: 'Recife', state: 'PE' },
        82: { city: 'Maceió', state: 'AL' },
        83: { city: 'João Pessoa', state: 'PB' },
        84: { city: 'Natal', state: 'RN' },
        85: { city: 'Fortaleza', state: 'CE' },
        86: { city: 'Teresina', state: 'PI' },
        87: { city: 'Petrolina', state: 'PE' },
        88: { city: 'Juazeiro do Norte', state: 'CE' },
        89: { city: 'Picos', state: 'PI' },
        91: { city: 'Belém', state: 'PA' },
        92: { city: 'Manaus', state: 'AM' },
        93: { city: 'Santarém', state: 'PA' },
        94: { city: 'Marabá', state: 'PA' },
        95: { city: 'Boa Vista', state: 'RR' },
        96: { city: 'Macapá', state: 'AP' },
        97: { city: 'Coari', state: 'AM' },
        98: { city: 'São Luís', state: 'MA' },
        99: { city: 'Imperatriz', state: 'MA' },
      };
      const res = dddObject[phone.substring(0, 2)];
      return res !== undefined;
    },
    isValidPhone(phone) {
      if (!phone) return false;
      const filtered = phone.replace(/[() -]/g, '');
      if (filtered.length !== 11) return false;
      const split = filtered.split('');
      if (split[2] !== '9') return false;
      if (!this.isDDDValid(filtered)) return false;
      return true;
    },
    isValidDDDSpecific(phone) {
      const filtered = phone.replace(/[() -]/g, '');
      if (!this.isDDDValid(filtered)) return false;
      return true;
    },
    isValidCpf(cpf) {
      let maskedCpf = cpf;
      if (typeof maskedCpf !== 'string') return false;
      maskedCpf = maskedCpf.replace(/[^\d]+/g, '');
      if (maskedCpf.length !== 11 || !!maskedCpf.match(/(\d)\1{10}/)) return false;
      maskedCpf = maskedCpf.split('');
      const validator = maskedCpf
        .filter((digit, index, array) => index >= array.length - 2 && digit)
        .map((el) => +el);
      const toValidate = (pop) => maskedCpf
        .filter((digit, index, array) => index < array.length - pop && digit)
        .map((el) => +el);
      const rest = (count, pop) => (toValidate(pop)
        .reduce((soma, el, i) => soma + el * (count - i), 0) * 10) % 11 % 10;
      return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1]);
    },
    isValidZipCode(zipCode) {
      return zipCode && zipCode.replace('-', '').length === 8;
    },
    isValidShipping(shipping) {
      if (!shipping) return false;

      const shippingValidations = {
        zipCode(zipCode) {
          if (!zipCode) return false;
          return zipCode.length === 8;
        },
        default(key, value) {
          if (!['complement', 'addressComplement'].includes(key) && [undefined, null].includes(value)) {
            return false;
          }
          return true;
        },
      };

      const keys = Object.keys(shipping);
      let isValid = true;

      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        const value = shipping[key];

        const isValidKey = shippingValidations[key]
          ? shippingValidations[key](value)
          : shippingValidations.default(key, value);

        if (!isValidKey) {
          isValid = false;
          break;
        }
      }

      return isValid;
    },
    getInvalidInputs({ email, cpf, phone, shipping, isHomolog = false }) {
      const invalidInputs = [];
      if (email && email.includes('*')) invalidInputs.push('needAuthenticate');
      if (cpf && cpf.includes('*')) invalidInputs.push('needAuthenticate');
      if (phone && phone.includes('*')) invalidInputs.push('needAuthenticate');

      if (!this.isValidEmail(email)) invalidInputs.push('email');
      if (!isHomolog && !this.isValidCpf(cpf)) invalidInputs.push('cpf');
      if (!this.isValidPhone(phone)) invalidInputs.push('phone');
      if (!this.isValidShipping(shipping)) invalidInputs.push('shipping');
      if (!this.isValidDDDSpecific(phone)) invalidInputs.push('ddd');
      return invalidInputs;
    },
  },
};
